import { Configuration, LogLevel, BrowserCacheLocation } from '@azure/msal-browser';

/**
 * Two separate identities live in this app:
 *
 *  1. The ENGINEER (First Digital staff) — signs in to Deployment Manager itself with the
 *     single-tenant "FirstIQ Deployment Manager" app and gets a token for our API
 *     (role Deployment.Engineer, checked by the API).
 *
 *  2. The CUSTOMER's Global Admin — signs in during a deployment with the multi-tenant
 *     "Customer Connect" app (customer/customerAuth.ts). Their delegated tokens are forwarded to
 *     the API per request and never stored server-side.
 */

const TENANT_ID = import.meta.env.VITE_AZURE_TENANT_ID || 'ac8e7aa0-66a4-48cb-9769-f638ba74eb3e';
const CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID || '35203b8d-6f3b-4ebb-b005-27592ee3e0b8';

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: { cacheLocation: BrowserCacheLocation.SessionStorage, storeAuthStateInCookie: false },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
        else if (level === LogLevel.Warning) console.warn(message);
      },
      logLevel: LogLevel.Warning,
    },
    allowNativeBroker: false,
  },
};

/** Engineer sign-in + token for the Deployment Manager API. */
export const apiScopes = [`api://${CLIENT_ID}/user_impersonation`];
export const loginRequest = { scopes: apiScopes };

export const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL || 'https://fiq-deploy-api-prod.azurewebsites.net/api').replace(/\/+$/, '');

/** Multi-tenant app the customer GA signs in with (also returned by GET /api/me). */
export const customerAppClientId = import.meta.env.VITE_CUSTOMER_APP_CLIENT_ID || 'fa33ca1e-786e-4a0f-bbbd-25744ccf3d46';
